/**
 * planCommandMonitorAddFunctionModule Module
 *
 * Description: 策划中心 指挥监测中心 添加功能
 * Author: fanglijuan 2017-7-18
 */
"use strict";
angular.module("planCommandMonitorAddFunctionModule", [])
    .controller('planCommandMonitorAddFunctionCtrl', ['$scope', "trsHttpService", "$q",
        function($scope, trsHttpService, $q) {
            initData();
            initStatus();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {                 
                    uiSrefList:{
                     "10":'front.planningresource.commandMonitor.addfunction.areahotspots',
                     "12":'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     "13":'front.planningresource.commandMonitor.addfunction.manuscriptdiffusion',
                     "15":'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     "14":'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     '16': 'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     "11":'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     "17":'front.planningresource.commandMonitor.addfunction.selectedtopic',
                     '18': 'front.planningresource.commandMonitor.addfunction.selectedtopic'}//添加页面的额路由配置
                };
            }
            /*
             *[requestData description:获取数据]
             */
            function requestData() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'getaddfunclist',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.addFuncInfos = data.listr;//将信息赋值给addFuncInfos
                });
            }
        }
    ]);